import DomainModel from './DomainModel'

class CaseHistory extends DomainModel {
  constructor(private data: any[], private by: any, private state: string, private on: string, private difference?: string) {
    super()
  }

  getData = () => this.data
  getBy = () => this.by
  getState = () => this.state
  getOn = () => this.on
  getDifference = () => this.difference

  stringify = () => {
    return JSON.stringify({ data: this.data, by: this.by, state: this.state, on: this.on, difference: this.difference }, null, '  ')
  }

  format = () => {
    const stringified = this.stringify()
    return stringified
      .replace(/[{}""]/g, '')
      .replace(/.*id.*/g, '') //remove ids
      .replace(/^\n$/g, '')
  }
}

export default CaseHistory
